import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, FileText } from "lucide-react";
import { API, BACKEND } from "../lib/api";
import BukuView from "../components/BukuView";
import { KerangkaBaris, KeadaanGalat } from "../components/kit";

export default function Demo() {
  const [ring, setRing] = useState(null);
  const [buku, setBuku] = useState(null);
  const [galat, setGalat] = useState(null);

  const muat = () => {
    setGalat(null);
    Promise.all([API.get("/demo/ringkasan"), API.get("/demo/buku")])
      .then(([r, b]) => { setRing(r.data); setBuku(b.data); })
      .catch(() => setGalat("Data contoh gagal dimuat."));
  };
  useEffect(muat, []);

  return (
    <div className="min-h-screen flex flex-col">
      <div data-testid="spanduk-demo"
        className="bg-accent text-accent-foreground text-center text-xs font-semibold px-4 py-2 sticky top-0 z-30">
        DATA CONTOH — bukan data perusahaan yang sebenarnya
      </div>
      <header className="kaca border-b sticky top-8 z-20">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 h-14 flex items-center justify-between">
          <Link to="/" data-testid="tautan-beranda" className="flex items-center gap-2">
            <ShieldCheck size={18} className="text-primary" aria-hidden="true" />
            <span className="font-heading font-bold text-lg">PAM-IT</span>
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/verifikasi" className="hidden sm:inline-block px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">
              Cek surat
            </Link>
            <Link to="/masuk" data-testid="tautan-masuk" className="tombol-garis px-3 py-1.5 text-sm rounded">Masuk</Link>
          </div>
        </div>
      </header>

      <main className="flex-1 px-4 md:px-8 py-10 max-w-[1400px] w-full mx-auto">
        {galat && <KeadaanGalat testid="galat-demo" pesan={galat} onCoba={muat} />}
        {!ring && !galat && <KerangkaBaris testid="memuat-demo" n={5} />}
        {ring && (
          <>
            <p className="label-kecil">Sekilas keadaan</p>
            <p data-testid="kalimat-temuan-demo" className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold max-w-3xl leading-tight">
              Ada <span className="text-accent font-data">{ring.tak_bertuan}</span> akun yang masih hidup padahal orangnya
              sudah keluar. Yang terlama <span className="text-accent font-data">{ring.tertua_hari}</span> hari.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="panel panel-hover rounded p-5" data-testid="kartu-tak-bertuan">
                <p className="label-kecil">Akun tanpa pemilik</p>
                <p className="font-data text-4xl font-bold mt-3">{ring.tak_bertuan}</p>
              </div>
              <div className="panel panel-hover rounded p-5">
                <p className="label-kecil">Menganggur terlama</p>
                <p className="font-data text-4xl font-bold mt-3">
                  {ring.tertua_hari}<span className="text-base text-muted-foreground"> hari</span>
                </p>
              </div>
              <div className="panel panel-hover rounded p-5">
                <p className="label-kecil">Akses yang terdampak</p>
                <p className="font-data text-4xl font-bold mt-3">{ring.jumlah_sistem}</p>
              </div>
              <div className="panel panel-hover rounded p-5">
                <p className="label-kecil">Surat yang sudah terbit</p>
                {ring.surat ? (
                  <a data-testid="tautan-pdf-demo" href={`${BACKEND}/api/surat/pdf/${ring.surat.token}`} target="_blank" rel="noreferrer"
                    className="mt-3 inline-flex items-center gap-2 font-data text-sm font-bold text-primary hover:underline">
                    <FileText size={15} /> {ring.surat.nomor}
                  </a>
                ) : <p className="mt-3 text-sm text-muted-foreground italic">belum ada (n=0)</p>}
                {ring.surat && (
                  <Link to={`/verifikasi/${ring.surat.nomor}`} data-testid="tautan-cek-surat-demo"
                    className="mt-2 block text-xs text-muted-foreground hover:text-foreground transition-colors duration-150">
                    cek keasliannya →
                  </Link>
                )}
              </div>
            </div>

            <div className="garis-cahaya my-12" />
            <h2 className="text-2xl font-bold">Akses yang masih terbuka</h2>
            <p className="mt-2 text-sm text-muted-foreground">
              Klik nama aksesnya untuk melihat siapa saja yang masih terdaftar di dalamnya.
            </p>
            <div className="mt-6">{buku && <BukuView data={buku} />}</div>
          </>
        )}
      </main>
    </div>
  );
}
